<template>
  <!-- Footer -->
  <footer class="footer">
    <strong>通讯管理机</strong> v1.0.0 &copy; 版权所有 2017
  </footer>
  <!-- // Footer -->
</template>

<script>
export default {
  name: 'footer',
  data () {
    return {
      msg: '欢迎使用通讯管理机配置工具'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Footer.vue?24158ac4